import renderParts from "../renderParts";

import "./Description.scss";

export default function Description({ text, parts, bold, classes = [], style }) {
  return (
    <p className={`description ${classes.join(" ")}`} style={style}>
      <span>{bold}</span>
      {parts ? renderParts(parts) : text}
    </p>
  );
}
